import React from "react";
import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import CalendarTodayRounded from "@mui/icons-material/CalendarTodayRounded";
import TuneRounded from "@mui/icons-material/TuneRounded";
import EditNoteRounded from "@mui/icons-material/EditNoteRounded";
import NotificationsActiveRounded from "@mui/icons-material/NotificationsActiveRounded";
import EventAvailableRounded from "@mui/icons-material/EventAvailableRounded";
import PeopleAltRounded from "@mui/icons-material/PeopleAltRounded";
import PersonSearchRounded from "@mui/icons-material/PersonSearchRounded";
import GroupsRounded from "@mui/icons-material/GroupsRounded";
import CampaignRounded from "@mui/icons-material/CampaignRounded";
import SearchRounded from "@mui/icons-material/SearchRounded";

const StepRow: React.FC<{
    icon: React.ReactNode;
    text: string;
    hex: string;
}> = ({ icon, text, hex }) => (
    <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
            sx={{
                width: 28,
                height: 28,
                minWidth: 28,
                borderRadius: "8px",
                bgcolor: alpha(hex, 0.08),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: hex,
            }}
        >
            {icon}
        </Box>
        <Typography
            fontSize="13px"
            lineHeight="140%"
            color="text.primary"
            fontWeight={400}
            textAlign="left"
        >
            {text}
        </Typography>
    </Stack>
);

const DayOffContent: React.FC = () => {
    const theme = useTheme();
    const hex = theme.palette.primary.main;

    return (
        <Stack spacing={2} alignItems="center">
            <Typography
                fontSize="14px"
                lineHeight="150%"
                color="text.secondary"
                textAlign="center"
            >
                Your AI admin handles everything — clients get notified and
                rebooked automatically.
            </Typography>

            <Stack
                spacing={1.5}
                sx={{
                    width: "100%",
                    bgcolor: alpha(hex, 0.03),
                    borderRadius: "14px",
                    p: 2,
                }}
            >
                <StepRow
                    icon={<CalendarTodayRounded sx={{ fontSize: 15 }} />}
                    text="Pick a day and time"
                    hex={hex}
                />
                <StepRow
                    icon={<TuneRounded sx={{ fontSize: 15 }} />}
                    text="Add a discount if you want"
                    hex={hex}
                />
                <StepRow
                    icon={<EditNoteRounded sx={{ fontSize: 15 }} />}
                    text="Write a message — or let AI do it"
                    hex={hex}
                />
                <StepRow
                    icon={<NotificationsActiveRounded sx={{ fontSize: 15 }} />}
                    text="Clients get notified with new slots"
                    hex={hex}
                />
                <StepRow
                    icon={<EventAvailableRounded sx={{ fontSize: 15 }} />}
                    text="Calendar updates automatically"
                    hex={hex}
                />
            </Stack>
        </Stack>
    );
};

const FillDayContent: React.FC = () => {
    const theme = useTheme();
    const hex = theme.palette.primary.main;

    return (
        <Stack spacing={2} alignItems="center">
            <Typography
                fontSize="14px"
                lineHeight="150%"
                color="text.secondary"
                textAlign="center"
            >
                AI scans your free slots and sends targeted offers to fill
                your day.
            </Typography>

            <Stack
                spacing={1.5}
                sx={{
                    width: "100%",
                    bgcolor: alpha(hex, 0.03),
                    borderRadius: "14px",
                    p: 2,
                }}
            >
                <StepRow
                    icon={<SearchRounded sx={{ fontSize: 15 }} />}
                    text="Free slots are matched to your services"
                    hex={hex}
                />
                <StepRow
                    icon={<PeopleAltRounded sx={{ fontSize: 15 }} />}
                    text="Waitlist clients get priority"
                    hex={hex}
                />
                <StepRow
                    icon={<PersonSearchRounded sx={{ fontSize: 15 }} />}
                    text="Then clients with similar bookings"
                    hex={hex}
                />
                <StepRow
                    icon={<GroupsRounded sx={{ fontSize: 15 }} />}
                    text="Remaining slots go to your full base"
                    hex={hex}
                />
                <StepRow
                    icon={<CampaignRounded sx={{ fontSize: 15 }} />}
                    text="An Instagram post is prepared for you"
                    hex={hex}
                />
            </Stack>
        </Stack>
    );
};

export const dayOffModalContent = {
    header: "Free Up Your Day",
    text: <DayOffContent />,
    button: "Start",
};

export const fillDayModalContent = {
    header: "Fill Your Day",
    text: <FillDayContent />,
    button: "Start",
};
